import axios from "axios";
import QS from "qs";
import { Toast } from "vant";
import router from "../router";

// 进行一些全局配置
// 公共路由(网络请求地址)
const baseURL = "https://wap.xiguatrace.cn/wapi";
axios.defaults.baseURL = baseURL;

// 请求响应超时时间
axios.defaults.timeout = 5000;

// post请求头
// axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.headers.post["Content-Type"] = "application/json";

// 请求拦截
axios.interceptors.request.use(
  config => {
    if (sessionStorage.obdtk) {
      config.headers.obdtk = sessionStorage.obdtk;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    const { status } = error.response;

    switch(status) {
      case 401:
        router.push("/login");
      break;

      case 403:
        Toast({                 
          message: "登录过期，请重新登录",
          duration: 1000,
          forbidClick: true
        });
        // 清除token                    
        sessionStorage.removeItem("obdtk");
        router.push("/login");
      break;

      case 404:
        Toast({                 
          message: "网络请求不存在",
          duration: 1000,
          forbidClick: true
        });
      break;

      default:
        Toast({
          message: error.response.data.message,
          duration: 1500,
          forbidClick: true
        });
    }
    return Promise.reject(error);
  }
);

export default axios;

// get方法，对应get请求
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(baseURL + url, {
        params: params,
      }).then(res => {
        resolve(res.data);
      }).catch(err => {
        reject(err.data);
      });
  });
}

// post方法，对应post请求
export function post(url, params) {    
  return new Promise((resolve, reject) => {         
    axios.post(baseURL + url, params).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  });
}




// WEBPACK FOOTER //
// ./src/api/http.js